import io from "socket.io-client";
export const socket = io("https://space-bet-backend.onrender.com");
